import { SET_CUSTOM_COORDINATES } from "@reducers/options/screw/actions";

export const SET_BASE_PLATE_FACTOR_A = 'SET_BASE_PLATE_FACTOR_A';

export const SET_STAND_OFF_DIMENSION = 'SET_STAND_OFF_DIMENSION';
export const SET_STAND_OFF_RESTRAINT_LEVEL = 'SET_STAND_OFF_RESTRAINT_LEVEL';
export const SET_STAND_OFF_MORTAR_STRENGTH = 'SET_STAND_OFF_MORTAR_STRENGTH';

export const SET_SLOTTED_HOLES_ACTIVE_BTN = 'SET_SLOTTED_HOLES_ACTIVE_BTN';
export const SET_ORIENTATION_ACTIVE_BTN = 'SET_ORIENTATION_ACTIVE_BTN';

export const SET_GRADE_STEEL_BAR = 'SET_GRADE_STEEL_BAR';

export const SET_BEAM_OFFSET = 'SET_BEAM_OFFSET';
export const SET_BASEPLATE_OPTIONS = 'SET_BASEPLATE_OPTIONS';
export const SET_SAFETY_BARRIER_DIMENSIONS = 'SET_SAFETY_BARRIER_DIMENSIONS';
export const SET_PEDESTAL_DIMENSIONS = 'SET_PEDESTAL_DIMENSIONS';
export const SET_STAIRS_DIMENSIONS = 'SET_STAIRS_DIMENSIONS';
export const SET_WALL_DIMENSIONS = 'SET_WALL_DIMENSIONS';

export const SET_DIMENSIONS_CONCRETE_MEMBER = 'SET_DIMENSIONS_CONCRETE_MEMBER';

export const RESET_DIMENSION_STATE = 'RESET_DIMENSION_STATE';
export const SET_DIMENSION_STATE = 'SET_DIMENSION_STATE';

export const SET_WOOD_BRACKET_OPTIONS = 'SET_WOOD_BRACKET_OPTIONS';
export const SET_NAILS_CONFIGURATION = 'SET_NAILS_CONFIGURATION';
export const SET_ANCHORS_CONFIGURATION = 'SET_ANCHORS_CONFIGURATION';

/*
  Action creators
 */
export function setDimensionState(state) {
  return { type: SET_DIMENSION_STATE, state };
}
export function setBasePlateFactorA(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_BASE_PLATE_FACTOR_A, value, appType: getState().main.appType });
  };
}

export function setStandOffDimension(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_STAND_OFF_DIMENSION, value, appType: getState().main.appType });
  };
}
export function setStandOffRestraintLevel(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_STAND_OFF_RESTRAINT_LEVEL, value, appType: getState().main.appType });
  };
}
export function setStandOffMortarStrength(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_STAND_OFF_MORTAR_STRENGTH, value, appType: getState().main.appType });
  };
}

export function setSlottedHolesActiveBtn (id) {
  return { type: SET_SLOTTED_HOLES_ACTIVE_BTN, id };
}
export function setOrientationActiveBtn (id) {
  return { type: SET_ORIENTATION_ACTIVE_BTN, id };
}

export function setGradeSteelBar (value) {
  return { type: SET_GRADE_STEEL_BAR, value };
}

export function setBasePlateOptions(options){
  return (dispatch, getState) => {
    dispatch({ type: SET_BASEPLATE_OPTIONS, options, appType: getState().main.appType });
  };
}
export function setSafetyBarrierDimensions(options){
  return (dispatch) => {
    dispatch({ type: SET_SAFETY_BARRIER_DIMENSIONS, options });
  };
}
export function setPedestalDimensions(options){
  return (dispatch) => {
    dispatch({ type: SET_PEDESTAL_DIMENSIONS, options });
  };
}
export function setStairsDimensions(options){
  return (dispatch) => {
    dispatch({ type: SET_STAIRS_DIMENSIONS, options });
  };
}
export function setWallDimensions(options){
  return (dispatch) => {
    dispatch({ type: SET_WALL_DIMENSIONS, options });
  };
}

// Rebar
export function setDimensionsConcreteMember(options){
  return (dispatch) => {
    dispatch({ type: SET_DIMENSIONS_CONCRETE_MEMBER, options});
  };
}
// ~Rebar

export function resetDimensionState(appType){
  return (dispatch, getState) => {
    dispatch({ type: RESET_DIMENSION_STATE, appType: appType || getState().main.appType, country: getState().main.localization.country});
  };
}

export function setCustomCoordinates(isActive) {
  return (dispatch, getState) => {
    dispatch({ type: SET_CUSTOM_COORDINATES, appType: getState().main.appType, isActive});
  };
}

export function setWoodBracketOptions(options) {
  return (dispatch) => {
    dispatch({ type: SET_WOOD_BRACKET_OPTIONS, options });
  };
}

export function setNailsConfiguration(options) {
  return (dispatch) => {
    dispatch({ type: SET_NAILS_CONFIGURATION, options });
  };
}

export function setAnchorsConfiguration(options) {
  return (dispatch) => {
    dispatch({ type: SET_ANCHORS_CONFIGURATION, options });
  };
}



// WEBPACK FOOTER //
// ./src/reducers/selectors/dimension/actions.js